import React from 'react';
import { Link } from 'react-router-dom';

const EmailPolicyPage: React.FC = () => {
  return (
    <div className="w-full min-h-screen bg-slate-50">
      {/* Header - PrivacyPolicyPage와 동일한 디자인 */}
      <div className="w-full h-20 bg-white shadow-[0px_4px_4px_0px_rgba(0,0,0,0.01)]">
        <div className="max-w-[1920px] mx-auto px-4 h-full relative flex items-center">
          <Link to="/" className="md:block hidden">
            <div className="w-auto h-8 left-[40px] top-[26px] absolute whitespace-nowrap text-[#1A253F] text-[14px] md:text-[28px] font-extrabold font-pretendard leading-9">
              부산항신항시설관리센터
            </div>
          </Link>
          {/* Mobile Header */}
          <Link to="/" className="md:hidden block w-full">
            <div className="w-full h-7 text-center text-[#1A253F] text-[18px] md:text-[28px] font-extrabold font-pretendard leading-9">
              부산항신항시설관리센터
            </div>
          </Link>
        </div>
      </div>
      <div className="w-full h-px bg-white border border-slate-200"></div>

      {/* Main Content - PrivacyPolicyPage와 동일한 디자인 */}
      <div className="w-[760px] mx-auto relative pt-8">
        {/* 헤더 섹션 */}
        <div className="mt-8">
          <div className="text-slate-800 text-4xl font-extrabold font-['Pretendard'] leading-9">
            이메일 무단수집 거부
          </div>
          <div className="w-full h-px mt-8 outline outline-1 outline-offset-[-0.50px] outline-neutral-200"></div>
        </div>

        {/* 본문 내용 */}
        <div className="mt-8 bg-white rounded-sm outline outline-1 outline-slate-200">
          <div className="p-8">
            {/* 기본 안내사항 */}
            <div className="mb-8">
              <h2 className="text-[#1e2c49] text-xl font-bold font-['Pretendard'] leading-9 mb-4">
                이메일 주소 무단수집 금지
              </h2>
              <div className="w-[calc(100%-64px)] h-px outline outline-1 outline-offset-[-0.50px] outline-[#e5e8eb] mb-6"></div>
              <p className="text-[#1e2c49] text-[19px] font-medium leading-relaxed">
                본 웹사이트에 게시된 이메일 주소가 전자우편 수집 프로그램이나 그 밖의 기술적 장치를 이용하여 무단으로 수집되는 것을 거부하며, 이를 위반 시 관계법령에 의해 처벌 받을 수 있습니다.
              </p>
            </div>

          </div>
        </div>
      </div>

      {/* 푸터 */}
      <footer className="bg-[#0E2039] h-[340px] md:h-[210px] mt-[100px]">
        <div className="max-w-[1380px] mx-auto px-4 sm:px-8 md:px-16 pt-[40px] md:pt-[54px]">
          <div className="flex flex-col md:flex-row justify-between">
            <div>
              <h4 className="text-[16px] md:text-[24px] font-semibold text-white/80 font-pretendard mb-[41px]">
                부산항신항시설관리센터
              </h4>
              <div className="flex flex-col md:flex-row items-start md:items-center gap-[8px] md:gap-[24px]">
                <p className="text-[14px] md:text-[15px] font-medium text-[#64AAC6] font-pretendard">Contact</p>
                <p className="text-[12px] font-light text-white/40 font-pretendard">
                  부산광역시 강서구 신항로 96-87
                </p>
                <div className="flex items-center gap-[8px]">
                  <p className="text-[12px] font-light text-white/40 font-pretendard">
                    대표번호:051-890-7400
                  </p>
                  <p className="text-[12px] font-light text-white/40 font-pretendard">
                    FAX:051-831-5344
                  </p>
                </div>
              </div>
            </div>
                         <div className="flex flex-col md:flex-row gap-[8px] md:gap-[44px] mt-[20px] md:mt-0">
               <Link to="/notices" className="text-[14px] md:text-[15px] font-bold text-white font-pretendard">공지사항</Link>
               <Link to="/privacy" className="text-[14px] md:text-[15px] font-bold text-white font-pretendard">개인정보처리방침</Link>
               <Link to="/email-policy" className="text-[14px] md:text-[15px] font-bold text-white font-pretendard">이메일무단수집거부</Link>
             </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default EmailPolicyPage; 